import { useCustomTranslation } from '../../../localization/hooks/useCustomTranslation';
import { moduleId } from '../config';

export const useCoreTranslation = (keyPrefix: string) =>
  useCustomTranslation({ moduleId, keyPrefix });
